// extracted by mini-css-extract-plugin
module.exports = {"linksWrapperMob":"SocialLinks-module--linksWrapperMob--FfLuF","linksWrapperDesk":"SocialLinks-module--linksWrapperDesk--1Nons","socialLink":"SocialLinks-module--socialLink--rUK9F"};